export default __webpack_public_path__ + "static/2120-565dd2fa26c36ce1d2182b11a2022c79.gif";